import { useSyncExternalStore } from "react";

import { readCssVariable } from "../read-css-variable";

function subscribeDocumentTheme(onStoreChange: () => void) {
  if (typeof document === "undefined") return () => undefined;
  const observer = new MutationObserver(onStoreChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class", "data-color-theme"],
  });
  return () => observer.disconnect();
}

export function useCssVariable(name: `--${string}`, fallback = ""): string {
  return useSyncExternalStore(
    subscribeDocumentTheme,
    () => readCssVariable(name, fallback),
    () => fallback,
  );
}
